import { usePathname, useSearchParams } from 'next/navigation'
import { useLayoutEffect } from 'react'

import { useNavigationActions } from '@/components/providers/NavigationProvider'
import { useReduxDispatch } from '@/store/hooks'
import { modalActions } from '@/store/modal'
import { viewActions } from '@/store/view'
import { scrollToTarget } from '@/utils/scrollUtil'

export const ScrollListener = () => {
  const dispatch = useReduxDispatch()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const { consumeScrollRequest } = useNavigationActions()

  useLayoutEffect(() => {
    dispatch(viewActions.closeMobileMenus())
    dispatch(modalActions.closeAll())

    const scrollRequest = consumeScrollRequest()

    if (!scrollRequest) return

    // Fix tabs scrolling to top on Safari iOS
    window.scrollTo(0, scrollRequest.scrollY)
    scrollToTarget({ hash: window.location.hash.slice(1), scroll: scrollRequest.scroll })
  }, [consumeScrollRequest, dispatch, pathname, searchParams])

  return null
}
